// 商品状态
export let goodsState = [{
    label: '已保存',
    value: 'DRAFT'
  }, {
    label: '待审核',
    value: 'WAITING_FOR_APPROVAL'
  }, {
    label: '被驳回',
    value: 'REJECTED'
  }, {
    label: '已上架',
    value: 'PUBLISHED'
  }, {
    label: '已下架',
    value: 'OFF_SHELVES'
  }]
  // 自营品类型枚举
export let platformType = [{
      label: '基因检测',
      value: 'GENE'
    },
    {
      label: '细胞存储',
      value: 'CELLULA_STORE'
    }
  ]
  // 第三方商品类型枚举
export let thirdPartyType = [{
      label: '体检',
      value: 'PHYSICAL'
    },
    {
      label: '医美',
      value: 'BEAUTY'
    },
    {
      label: '口腔',
      value: 'ORAL'
    },
    {
      label: '保险',
      value: 'INSURANCE'
    },
    {
      label: '美业',
      value: 'BEAUTY_INDUSTRY'
    },
    {
      label: '母婴百货',
      value: 'INFANT_MOM_GOODS'
    }
  ]
  // 商品类型
export let goodsType = platformType.concat(thirdPartyType)
  // 分组相关
export let collationRules = [{
    label: '按推荐值排序',
    value: 'RECOMMEND_DESC'
  },
  {
    label: '按创建时间升序排列',
    value: 'CREATE_DATE_ASC'
  },
  {
    label: '按创建时间降序排列',
    value: 'CREATE_DATE_DESC'
  }
]

// 优惠劵状态
export let couponStatusArr = [{
      label: '未提交',
      value: 'WAITING_COMMIT'
    },
    {
      label: '待审核',
      value: 'WAITING_AUDIT'
    },
    {
      label: '已激活',
      value: 'ACTIVATED'
    },
    {
      label: '已结束',
      value: 'DISABLED'
    },
    {
      label: '审核驳回',
      value: 'REJECTION'
    },
    {
      label: '已失效',
      value: 'NON_RECEIVABLE'
    }
  ]
  // 促销活动（优惠/返现通用促销活动）状态
export let promotionStatusArr = [{
      label: '未提交',
      value: 'WAITING_COMMIT'
    },
    {
      label: '待客服审核',
      value: 'WAITING_AUDIT'
    },
    {
      label: '待财务审核',
      value: 'WAITING_FINANCIAL_AUDIT'
    },
    {
      label: '已激活',
      value: 'ACTIVATED'
    },
    {
      label: '已结束',
      value: 'DISABLED'
    },
    {
      label: '客服驳回',
      value: 'REJECTION'
    },
    {
      label: '财务驳回',
      value: 'FINANCIAL_REJECTION'
    },
    {
      label: '已失效',
      value: 'NON_RECEIVABLE'
    }
  ]
  // 折扣类型
export let discountType = [{
      label: '固定额度',
      value: 'FIXED_AMOUNT'
    },
    {
      label: '比率折扣',
      value: 'PROPORTION'
    }
  ]
  // 优惠劵发布方式
export let publishType = [{
    label: '发放',
    value: 'GRANT'
  },
  {
    label: '领取',
    value: 'RECEIVE'
  },
  {
    label: '下载优惠劵',
    value: 'QR_CODE'
  },
  {
    label: '活动赠券',
    value: 'BY_OTHER_PROMOTION'
  },
  {
    label: '积分兑换券',
    value: 'BY_POINTS'
  },
  {
    label: '邀新赠券',
    value: 'INVITE_NEW_USER_REWARD'
  },
  {
    label: '邀请家人注册成功奖励',
    value: 'INVITE_FAMILY_REWARD'
  }
]

// 优惠券类型是否要限制数量
export function couponTypeHasLimit(data) {
  // 目前只有领取型优惠券有数量限制
  return data.grantType === 'RECEIVE' || data.couponData.usedType === 'OFFLINE'
    // return type === 'RECEIVE'
}

// 优惠劵发布对象
export let grantObj = [{
      label: '所有用户',
      value: 'ALL_USER'
    },
    {
      label: '指定用户',
      value: 'DESIGNATED_USER'
    },
    {
      label: '邀新奖励',
      value: 'MEET_CONDITIONS_USER'
    }
    //   {
    //     label: '邀新奖励(每邀请一个新用户获得一张优惠劵)',
    //     value: 'INVITE_NEW_USER_REWARD'
    //   }
  ]
  // 促销活动类型枚举
export let promotionTypes = [{
      label: '限时优惠',
      value: 'TIME_LIMIT_DISCOUNT'
    },
    {
      label: '秒杀',
      value: 'SNAP_UP'
    },
    {
      label: '优惠礼包活动',
      value: 'COUPONS_PACKAGE'
    },
    {
      label: '优惠/返现通用活动',
      value: 'CASH_BACK'
    },
    {
      label: 'CPS奖励',
      value: 'CPS_BIND'
    }
  ]
  // 商品归属枚举
export let goodsBelongLabels = [{
      label: '自营商品',
      value: 'PLATFORM'
    },
    {
      label: '第三方商品',
      value: 'THIRD_PARTY'
    }
  ]
  // 新建/编辑第三方商品的时候，收款账户枚举
export let collectionsLabels = [{
      label: '平台账户',
      value: 'PLATFORM'
    },
    {
      label: '供应商账户',
      value: 'THIRD_PARTY'
    },
    {
      label: '分子公司',
      value: 'MOLECULAR_COMPANY'
    },
    {
      label: '根据表单判断支付对象',
      value: 'COMPANY_ACCORDING_TO_FORM'
    },
    {
      label: '商城订单所属公司',
      value: 'MALL_ORDER_ORGANIZATION'
    },
    {
      label: '免疫细胞存储',
      value: 'IMMUNE_STORAGE'
    }
  ]
  // 商品是否需要发货
export let shippingMode = [{
      label: '实体商品（需发货）',
      value: 'EXPRESS'
    },
    {
      label: '虚拟商品',
      value: 'ONLINE'
    },
    {
      label: '无需发货',
      value: 'NONE'
    }
  ]
  // 商品周期类型
export let cycleTypes = [{
      label: '自然日',
      value: 'NATURAL_DAY'
    },
    {
      label: '工作日',
      value: 'WORKING_DAY'
    }
  ]
  // 检测项周期
export let dayTypes = [{
      label: '自然日',
      value: 'NATURAL_DAY'
    },
    {
      label: '工作日',
      value: 'WORK_DAY'
    }
  ]
  // 商品弹框，选择商品的表格label
export let selectGoodsTableLabels = [{
      label: '商品名称',
      value: 'goodsDTO.goodsData.name'
    },
    {
      label: '商品价格（元）',
      value: 'final_price'
    },
    {
      label: '商品归属',
      value: 'goodsBelong'
    },
    {
      label: '库存',
      value: 'goodsOtherInfoDTO.stockQuantity'
    }
  ]
  // 第三方供应商类型
export let vendorsType = [{
    label: '美业',
    value: 'BEAUTY'
  },
  {
    label: '分公司',
    value: 'BRANCH'
  },
  {
    label: '体检机构',
    value: 'MEDICAL'
  },
  {
    label: '直销销售',
    value: 'DIRECT_SELLING'
  },
  {
    label: '医美',
    value: 'MEDICAL_BEAUTY'
  },
  {
    label: '口腔',
    value: 'ORAL'
  },
  {
    label: '快消品',
    value: 'QUICK_SALES'
  },
  {
    label: '美业',
    value: 'BEAUTY_INDUSTRY'
  },
  {
    label: '母婴百货',
    value: 'INFANT_MOM_GOODS'
  }
]

// 第三方供应商类型
export let workOrderType = [{
      label: '待处理',
      value: 'WAITFOR_HANDING'
    },
    {
      label: '已导出',
      value: 'EXPORTED'
    }
  ]
  // 第三方供应商发票类型
export let invoiceType = [{
      label: '增值税专用发票',
      value: 'SPECIAL_VAT'
    },
    {
      label: '增值税普通发票',
      value: 'ORDINARY_VAT'
    }
  ]
  // 第三方供应商可开具的发票类型
export let invoiceProvideType = [{
      label: '电子发票',
      value: 'ELECTRONIC'
    },
    {
      label: '纸质发票',
      value: 'PAPER'
    }
  ]
  // 发票对象
export let invoiceObject = [{
    label: '个人',
    value: 'PERSONAL'
  },
  {
    label: '公司',
    value: 'ORGANIZATIONAL'
  }
]
export let invoiceProvideTypesDo = [{
      label: '电子发票',
      value: 'ELECTRIC'
    },
    {
      label: '纸质发票',
      value: 'MAILING'
    }
  ]
  // 老带新,发放状态枚举
export let rewardStatus = [{
      label: '未发放',
      value: 'NO_REWARD'
    },
    {
      label: '待客服审核',
      value: 'WAITING_FOR_APPROVAL'
    },
    {
      label: '待财务审核',
      value: 'SALES_COMPLETED'
    },
    {
      label: '客服已驳回',
      value: 'SALES_REJECTED'
    },
    {
      label: '财务已驳回',
      value: 'REJECTED'
    },
    {
      label: '已完成',
      value: 'COMPLETED'
    },
    {
      label: '已退款',
      value: 'REFUND'
    }
  ]
  // 支付方式
export let paymentModes = [{
    label: '全款',
    value: 'LUMP_SUM'
  },
  {
    label: '订金+尾款',
    value: 'DEPOSIT_AND_BALANCE'
  }
]
export let promotionColors = {
  'SNAP_UP': '#F56C6C',
  'TIME_LIMIT_DISCOUNT': '#EF840D',
  'CASH_BACK': '#F56C6C'
}

export let usedTypes = [{
      label: '商城中使用',
      value: 'ONLINE'
    },
    {
      label: '第三方兑换码',
      value: 'OFFLINE'
    }
  ]
  //存储状态枚举
export let thirdStatusOptions = [{
    label: "执行中",
    value: "EXECUTING"
  },
  {
    label: "已存储",
    value: "STORED"
  }
]